import { Field, FieldType } from '../types';

export const calculateFieldsLength = (fields: Field[]) =>
  fields.reduce(
    (accumulation, nextField) => accumulation + (nextField.type === FieldType.ATTACHMENT ? 0 : 1),
    0
  );
